module.exports = {
    'h1-mobile': '30px',
    'h1-tablet': '30px',
    'h1-desktop': '40px',
    'h1-desktop-l': '40px',
  }
  


// WEBPACK FOOTER //
// ./src/vars/typography.js